module.exports = {
      id: "icon-pause-usage",
      viewBox: "0 0 17.726 22.137",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }